import countriesData from './countries.json';

type Division = {
  [code: string]: string;
}

type Country = {
  name: string;
  divisions: Division;
}

type Countries = {
  [code: string]: Country;
}

export const iso3166: Countries = countriesData;

export default iso3166;